module.exports = __webpack_public_path__ + "static/media/ad-user-add-new-plus-icon-512.f1ad2434.png";